import { therapyPlanningAction } from 'src/redux/actions/constant';
const {
     CHECK_SPLIT_TEMPLATE_REQUEST,
  CHECK_SPLIT_TEMPLATE_SUCCESS,
  CHECK_SPLIT_TEMPLATE_FAILURE,
  CHECK_SPLIT_TEMPLATE_LOADING,
  CHECK_SPLIT_TEMPLATE_RESET,
}= therapyPlanningAction

const initialState: object = {
  response: null,
  getSplitTask: false,
  loading: false,
  requestedPayload:null,
  sourceTemp:null
};

export const checkSplitMinInPlanner = (state = initialState, action: any) => {
  switch (action.type) {
    case CHECK_SPLIT_TEMPLATE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        getSplitTask: true,
        loading: false,
        requestedPayload:action?.requestedPayload,
        sourceTemp:action?.sourceTemp
      };
    }
    case CHECK_SPLIT_TEMPLATE_FAILURE : {
      return {
        ...state,
        response: action.payload,
        getSplitTask: false,
        loading: false,
      };
    }

    case CHECK_SPLIT_TEMPLATE_LOADING:
      return {
        ...state,
        loading: true,
      };

    case CHECK_SPLIT_TEMPLATE_RESET:
      return initialState   


    default:
      return state;
  }
};
